import { InfoIcon } from "@cynthai/icons";
import { Link as RouterLink } from "@tanstack/react-router";
import { DialogTrigger, Button, Popover, Dialog } from "react-aria-components";

import { m } from "@/paraglide/messages";

type SidebarSupportMenuProps =
  | {
      variant: "admin";
      isOpen: boolean;
      onOpenChange: (isOpen: boolean) => void;
      closeProfileMenu: () => void;
    }
  | {
      variant: "normal";
      closeProfileMenu: () => void;
    };

export function SidebarSupportMenu(props: Readonly<SidebarSupportMenuProps>) {
  if (props.variant === "normal") {
    return (
      <RouterLink
        to="/help-center"
        onClick={props.closeProfileMenu}
        className="text-text-primary hover:bg-secondary flex h-10 items-center gap-3 rounded-lg px-2 text-base"
      >
        <InfoIcon width={20} height={20} />
        {m.help_center()}
      </RouterLink>
    );
  }

  const closeMenus = () => {
    props.closeProfileMenu();
  };

  return (
    <DialogTrigger isOpen={props.isOpen} onOpenChange={props.onOpenChange}>
      <Button className="text-text-primary hover:bg-secondary flex h-10 w-full items-center justify-start gap-3 rounded-lg px-2 text-base">
        <InfoIcon width={20} height={20} />
        {m.help_center()}
      </Button>
      <Popover
        isNonModal
        placement="right"
        offset={25}
        className="border-border bg-background-2 w-56 rounded-lg border p-3 shadow-xl outline-none"
      >
        <Dialog aria-label={m.help_center()}>
          <div className="flex flex-col gap-1 outline-none">
            <RouterLink
              to="/help-center"
              onClick={closeMenus}
              className="text-text-primary hover:bg-secondary flex h-10 items-center rounded-lg px-2 text-base"
            >
              {m.help_center()}
            </RouterLink>
            <RouterLink
              to="/help-center/admin/articles"
              onClick={closeMenus}
              className="text-text-primary hover:bg-secondary flex h-10 items-center rounded-lg px-2 text-base"
            >
              {m.help_center_admin()}
            </RouterLink>
          </div>
        </Dialog>
      </Popover>
    </DialogTrigger>
  );
}
